import React, { useEffect } from "react";
import { commonServices } from "../../../../api/services/commonServices";
import { claimService } from "../../../../api/services/claimService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { setLoading } from "../../../../infra/aggregates/LoaderSlice";

interface PropsValue {
  setTicketsType: (data: any) => void;
  setAllCountries: (countries: []) => void;
  setBenefitStatus: (status: string) => void;
}
const DTOApplyAirTicket = ({
  setTicketsType,
  setAllCountries,
  setBenefitStatus,
}: PropsValue) => {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  async function getTicketsType(emp_id:number,companyId: number) {
    dispatch(setLoading(true));
    const respose: any = await claimService.getTripTypes(emp_id,companyId);
    if (respose) {
      setTicketsType(respose?.data);
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
    }
  }
  async function getAllCountries() {
    const response = await commonServices.getCountries();
    if (response) {
      const { data }: any = response;
      setAllCountries(data);
    }
  }

  async function getEmployeeBenefitStatus(empId: number) {
    const response = await claimService.getEmployeeBenefitStatus(empId);
    if (response) {
      const { data }: any = response;
      setBenefitStatus(data?.name);
    }
  }

  useEffect(() => {
    if (selector.company_id) {
      getTicketsType(selector.emp_id,selector.company_id);
    }
    if (selector.emp_id) {
      getEmployeeBenefitStatus(selector.emp_id);
    }
    getAllCountries();
  }, []);

  return <></>;
};

export default DTOApplyAirTicket;
